module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_revivallabs.6ae328a02fff98847d4374a920e21ba6.png";